import "./Styles/Unauthenticated.css";
import logo from "../Images/Logos/AM2 Logo Colour Light.png";
import background from "../Images/Patterns/AM2_Pattern_A.png";
import {
  Text,
  Image,
  ImageFit,
  PrimaryButton,
  Stack,
  getTheme,
} from "@fluentui/react";
import { handleLogin } from "./Functions/Handlers";
import { useMsal } from "@azure/msal-react";

export const Unauthenticated = () => {
  const { instance, accounts, inProgress } = useMsal(); // eslint-disable-line no-unused-vars

  if (window.configs.FORCE_LOGIN) {
    handleLogin(instance, inProgress);
  }

  return (
    <div
      className="Unauthenticated"
      style={{
        backgroundImage: `url(${background})`,
      }}
    >
      <Stack horizontalAlign="center" style={{ padding: "80px" }}>
        <Stack.Item>
          <Image
            src={logo}
            imageFit={ImageFit.contain}
            width={320}
            height={320}
            className="Authenticating-logo"
            alt="logo"
          />
        </Stack.Item>

        <Stack.Item>
          {
            <Text
              styles={{
                root: {
                  color: getTheme().palette.neutralPrimary,
                },
              }}
            >
              {/* {props.error && (
                <div>
                  <Text
                    styles={{
                      root: {
                        color: getTheme().palette.neutralPrimary,
                      },
                    }}
                    variant="xLarge"
                  >
                    :(
                  </Text>
                  <p>
                    {"aeiou".indexOf(props.error.name) === -1 ? "A" : "An"}{" "}
                    {props.error.name ? props.error.name : "error"} occured
                    during authentication
                  </p>
                  <p>{props.error?.errorMessage}</p>
                </div>
              )} */}
            </Text>
          }
        </Stack.Item>

        <Stack.Item>
          {inProgress === "none" ? (
            <PrimaryButton
              // onClick={() => props.instance.acquireTokenRedirect(loginRequest)}
              onClick={handleLogin(instance, inProgress)}
            >
              Login
            </PrimaryButton>
          ) : (
            <Text
              styles={{
                root: {
                  color: getTheme().palette.neutralPrimary,
                },
              }}
            >
              {inProgress === "login"
                ? "Logging in..."
                : inProgress === "handleRedirect"
                ? "Redirecting..."
                : inProgress}
            </Text>
          )}
        </Stack.Item>
      </Stack>
    </div>
  );
};
